/*
 * component-custom-reviews_v3.js
 * PRYNTY — Custom Reviews & Modals
 * Version 3 — Popup fix & body class management
 * Copied from: component-custom-reviews.js (production / v2)
 * Updated: April 2026
 *
 * CHANGES vs v2 (production):
 *  1. [FIX] Changed classList.toggle('active') → classList.add('active') on
 *     the .reviews__container click handler. Using toggle caused a conflict:
 *     when both an inline onclick AND this listener fired, the modal would
 *     open and immediately close. Now open is exclusively via add, close via remove.
 *  2. [FIX] Added document.body.classList.add('reviews-modal-open') on open
 *     and classList.remove on close — this pauses the Glossy product shimmer
 *     animation while the modal is visible (CSS rule in component-custom-reviews.css).
 *  3. [FIX] All js-modal-close buttons now also remove 'reviews-modal-open'
 *     from body in addition to removing 'active' from the modal.
 */

// Open the review modal when clicking the rating/stars container
if (document.querySelector('.reviews__container')) {
  document.querySelector('.reviews__container').addEventListener('click', () => {
    const modal = document.querySelector('#formModal');
    if (modal) {
      modal.classList.add('active');
      document.body.classList.add('reviews-modal-open');
    }
  });
}

// Close any modal when clicking a js-modal-close button
document.querySelectorAll('.js-modal-close').forEach(button => {
  button.addEventListener('click', () => {
    const modal = button.closest('.modal');
    if (modal) {
      modal.classList.remove('active');
    }
    // Always clean up body class so glossy animation resumes
    document.body.classList.remove('reviews-modal-open');
  });
});


// Star rating widget — update displayed value and hidden input
const ratingInputs = document.querySelectorAll('input[name="rating"]');
const ratingValue = document.getElementById('rating-value');
const ratingInput = document.getElementById('rating-input');

ratingInputs.forEach((input) => {
  input.addEventListener('change', function () {
    if (ratingValue) ratingValue.textContent = this.value;
    if (ratingInput) ratingInput.value = this.value;
  });
});

// Open the request quote modal
if (document.querySelector('.request-toggle')) {
  document.querySelector('.request-toggle').addEventListener('click', () => {
    const modal = document.querySelector('#formRequestModal');
    if (modal) modal.classList.toggle('active');
  });
}
